export default __webpack_public_path__ + "static/media/vormatsLogo.png";